module.exports = ".filter input[type='text'] {\n  width: 100%;\n}\n\n.filter .checkbox {\n  margin-bottom: 0px;\n  padding-left: 10px;\n}\n\n.filter .checkbox.sub {\n  padding-left: 15px;\n}\n\n.checkbox.root label {\n  font-weight: bold;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/product.filter.css
// module id = ./src/app/Styles/product.filter.css
// module chunks = main